export const formatTime = (seconds: number, separator: string) =>
  `${Math.floor(seconds / 60)}${separator}${String(Math.floor(seconds % 60)).padStart(2, '0')}`;

export const transformMillisecToSec = (value: number) => Math.ceil(value / 1000);
